<mat-expansion-panel class="mat-elevation-z" #panel *ngFor="let coloredYarnSetWithStartDent of creel.coloredYarnSetsWithStartDent; let coloredYarnSetIndex = index" [expanded]="true">
  <mat-expansion-panel-header expandedHeight="54px" collapsedHeight="54px" [class.border-bottom]="panel.expanded">
    <mat-panel-title class="gap-16">
      <h3 class="font-weight-semibold">{{ coloredYarnSetWithStartDent.coloredYarnSet.name }}</h3>
      <app-color-list-preview
        [colorList]="coloredYarnSetWithStartDent.coloredYarnSet.overviewListColorSet"
        [maximumCreelPositionsToShow]="10"
        [creelMapping]="creel.mappingForCurrentPositionOnMachine[coloredYarnSetIndex]"
        [showDetailsOnClick]="false"
      >
      </app-color-list-preview>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <div>
    <div class="flex mb-16">
      <h3 class="font-weight-semibold flex-grow">
        {{ 'MACHINE.DETAILS.CREEL_MAPPING.TITLE' | bmsTranslate }}
      </h3>
      <div class="flex gap-16">
        <mat-label class="b1">{{ 'TEXTILE_DATA.COLOR.COLOR' | bmsTranslate: {count: 2} }}</mat-label>
        <mat-slide-toggle (change)="togglePreviewType($event, coloredYarnSetIndex)"></mat-slide-toggle>
        <mat-label class="b1">{{ 'TEXTILE_DATA.YARN_TYPE.YARN_TYPE' | bmsTranslate: {count: 2} }}</mat-label>
      </div>
    </div>
    <div>
      <app-creel-mapping-table
        [coloredYarnSetWithStartDent]="coloredYarnSetWithStartDent"
        [previewType]="getPreviewType(coloredYarnSetIndex)"
        [activeColoredYarnSetCreelMap]="creel.mappingForCurrentPositionOnMachine[coloredYarnSetIndex]"
      >
      </app-creel-mapping-table>
    </div>
  </div>
</mat-expansion-panel>
